import React from 'react'
import { FooterMoneyForBusiness } from '@shared/components/footer'
import { PageLayout } from '@shared/components/page-layout'
import { PageLayoutOwnProps } from '@shared/components/page-layout/model'
import { Empty } from '@shared/models'
import { NextPageFC } from '@shared/models/next-fc'
import { PagesPath, pagesTitles } from 'data/pages-titles'

import { MoneyForBusiness } from '../screens/money-for-business'

const MoneyForBusinessPage: NextPageFC<Empty, PageLayoutOwnProps> = () =>
	MoneyForBusiness({
		ratePoints: [
			'Ставка от 14,9% годовых',
			'Без финансовой отчётности',
			'Одобрение за 30 минут',
			'Никаких брокерских комиссий',
			'Без поручителей',
			'Можно оформить как физлицо',
		],
		minLoan: 5e5,
	})

MoneyForBusinessPage.layout = PageLayout

MoneyForBusinessPage.layoutProps = {
	menuProps: {
		hideLinksList: true,
	},
	customFooter: <FooterMoneyForBusiness />,
}

MoneyForBusinessPage.headProps = {
	canonicalLink: 'https://credit.club',
	title: pagesTitles[PagesPath.moneyForBusiness].title,
	description:
		'Быстрая выдача за 1 день. Можно оформить как физлицо. Не требуется финансовая отчётность компании',
	ogImageName: 'wow.jpg',
}

export default MoneyForBusinessPage
